import React from "react";

const NotAuthorized: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f9fa",
        color: "#333",
        fontFamily: "sans-serif",
      }}
    >
      <svg
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        style={{ marginBottom: 24 }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="#e74c3c" strokeWidth="2" />
        <path
          d="M8 12h8"
          stroke="#e74c3c"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M12 8v8"
          stroke="#e74c3c"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <h1 style={{ fontSize: "2rem", marginBottom: 12 }}>Not Authorized</h1>
      <p style={{ fontSize: "1.1rem", maxWidth: 400, textAlign: "center" }}>
        Sorry, you do not have permission to view this page.
        <br />
        Please contact us if you believe this is an error.
      </p>
    </div>
  );
};

export default NotAuthorized;
